<div class="top-page-controls">
  <div class="block-wrapper">
    <span class="go-to-company-title">
      <span class="company-slug" (click)="goToSearchPage()">{{ companySlug }} | </span>
      <span> {{ sourceSlug }} </span>
    </span>

    <ng-container #headerTemplate></ng-container>

    <div *ngIf="!isGeneralHeaderTemplate" class="mapping-actions-wrapper">
      <div class="configuration-folder-place">
        <div class="processing status" *ngIf="isCurrentDSInProcessing">
          <img class="spinner" src="assets/img/icons/ellipse.png" alt="" />
          <span class="label">{{ "sources.processingStatus" | translate }}</span>
        </div>
        <div class="update-statistic status" *ngIf="isUpdateStatisticAfterProcessing">
          <img class="spinner" src="assets/img/icons/ellipse.png" alt="" />
          <span class="label">{{ "sources.updateProcessingInfo" | translate }}</span>
        </div>
        <ng-container [ngSwitch]="dataSourceStatus">
          <div class="idle status" *ngSwitchCase="dataSourceStatuses.Idle" [matTooltip]="'Idle'" [matTooltipPosition]="'below'">
            <img class="spinner" src="assets/img/icons/spinner.png" alt="" />
            <span class="label">{{ "sources.status.idle" | translate }}</span>
          </div>
          <div
            class="progress status"
            *ngSwitchCase="dataSourceStatuses.InProgress"
            [matTooltip]="'In Progress'"
            [matTooltipPosition]="'below'"
          >
            <img class="spinner" src="assets/img/icons/ellipse.png" alt="" />
            <span class="label">{{ "sources.status.inProgress" | translate }}</span>
          </div>
          <div class="failed status" *ngSwitchCase="dataSourceStatuses.Failed" [matTooltip]="'Failed'" [matTooltipPosition]="'below'">
            <img src="assets/img/icons/failed.svg" alt="" />
            <span class="label">{{ "sources.status.failed" | translate }}</span>
          </div>
          <div
            class="cancelled status"
            *ngSwitchCase="dataSourceStatuses.Cancelled"
            [matTooltip]="'Cancelled'"
            [matTooltipPosition]="'below'"
          >
            <img class="spinner" src="assets/img/icons/spinner.png" alt="" />
            <span class="label">{{ "sources.status.cancelled" | translate }}</span>
          </div>
        </ng-container>
      </div>

      <div
        matTooltip="{{ 'sources.inProcessAlready' | translate }}"
        class="processing-tooltip"
        [matTooltipDisabled]="!isCurrentDSInProcessing"
      >
        <button
          mat-raised-button
          color="success"
          (click)="onProcessConfiguration()"
          [disabled]="isProcessingButtonDisabled()"
          [hidden]="isChanged"
          [matTooltip]="getProcessingButtonToolTip()"
        >
          <mat-icon>cloud_upload</mat-icon>

          <ng-container *ngIf="isMultiselectModeActive; else processItem">
            {{ "configuration-page.buttons.process-data-global-multiselect" | translate }}
          </ng-container>

          <ng-template #processItem>
            {{ "configuration-page.buttons.process-data-global" | translate }}
          </ng-template>
        </button>
      </div>

      <button mat-button color="primary" *ngIf="isChanged" (click)="cancelConfiguration()">
        <mat-icon>undo</mat-icon>
        {{ "configuration-page.buttons.cancel-global" | translate }}
      </button>
      <button mat-raised-button (click)="onUpdate()" [hidden]="!isChanged" [disabled]="isUpdateButtonDisabled()" color="primary">
        <mat-icon>check</mat-icon>
        {{ "configuration-page.buttons.update" | translate }}
      </button>
    </div>
  </div>
</div>

<div *ngIf="!configuration.RootFeatureLayerConfiguration">
  <h4 align="center">{{ "configuration.statistic.no-layers-msg" | translate }}</h4>
</div>

<div class="configuration-place">
  <mat-card class="block-wrapper">
    <div class="configuration-list-place" #tableHolder>
      <mat-tab-group #tabGroup (selectedTabChange)="onTabChange($event)" [selectedIndex]="selectedTabIndex">
        <mat-tab label="Mapping">
          <ng-template #recursiveList let-context>
            <ng-container *ngFor="let node of context.list; let i = index;">
              <tr
                *ngIf="showNode(node)"
                class="table-row"
                (click)="activateNode(node.node)"
                (mouseenter)="hoveredItemId = node.Id"
                (mouseleave)="hoveredItemId = null"
                [class.hover]="hoveredItemId === node.Id"
                [class.active]="activatedNode && activatedNode.Id === node.Id"
                [class.changed]="node.changed"
                [class.selected]="isNodeSelected(node)"
              >
                <td
                  *ngFor="let row of context.rows;"
                  [ngSwitch]="row.key"
                  (contextmenu)="onContextMenu($event, node)"
                  [ngClass]="row.className"
                  [id]="node.Id"
                  [style.padding-left]="context.fixed && getPaddingForNode(node)"
                  [style.border-color]="row.key === 'MainColor' || row.key === 'SecondColor' ? node[row.key] : null"
                  [style.background-color]="row.key === 'MainColor' ? node[row.key] : null"
                  [class]="'row-' + row.key"
                  [class.leaf]="node.isLeaf || node.isSubtype"
                  [class.has-children]="node.hasChildren"
                >
                  <!--LayerName Column-->

                  <div
                    *ngIf="context.fixed"
                    [ngStyle]="{ opacity: node.node.IsExcludedFromProcessing ? '0.4' : '1' }"
                    class="layerName-place"
                  >
                    <ng-container *ngIf="node.hasChildren">
                      <mat-icon class="arrow-icon" *ngIf="!node.isRoot && !node.expanded && !sortMode" (click)="expandNode($event, node)">
                        keyboard_arrow_right
                      </mat-icon>
                      <mat-icon class="arrow-icon" *ngIf="(!node.isRoot && node.expanded) || sortMode" (click)="collapseNode($event, node)">
                        keyboard_arrow_down
                      </mat-icon>
                    </ng-container>

                    <div *ngIf="!node.isSubtype" (click)="$event.stopPropagation()">
                      <mat-checkbox
                        class="select-node-checkbox without-label"
                        color="primary"
                        *ngIf="!node.isRoot"
                        [checked]="isNodeSelected(node)"
                        (change)="onSelectNode($event, node.node)"
                      ></mat-checkbox>
                    </div>

                    <div *ngIf="node.isRoot" (click)="$event.stopPropagation()">
                      <mat-checkbox
                        [checked]="isSelectedNodes && isAllNodesSelected"
                        [indeterminate]="isSelectedNodes && !isAllNodesSelected"
                        class="select-node-checkbox without-label"
                        color="primary"
                        (change)="selectAllNodes()"
                      >
                      </mat-checkbox>
                    </div>

                    <ng-container *ngIf="node.isBranch">
                      <mat-icon *ngIf="isShowFolderIcon(node.node); else show3DModelIcon" class="folder-icon">folder </mat-icon>
                      <ng-template #show3DModelIcon>
                        <img src="/assets/img/icons/3d.svg" class="type-icon" alt="" />
                      </ng-template>
                    </ng-container>

                    <ng-container *ngIf="node.isLeaf">
                      <ng-container *ngIf="isShowObjectTypeIcon(node.node); else showLayerIcon" [ngSwitch]="node.node.ObjectType">
                        <img src="/assets/img/icons/unknown.svg" class="type-icon" *ngSwitchCase="ObjectType.UNKNOWN" alt="" />
                        <img src="/assets/img/icons/point.svg" class="type-icon" *ngSwitchCase="ObjectType.POINT" alt="" />
                        <img src="/assets/img/icons/line.svg" class="type-icon" *ngSwitchCase="ObjectType.LINE" alt="" />
                        <img src="/assets/img/icons/area.svg" class="type-icon" *ngSwitchCase="ObjectType.AREA" alt="" />
                        <img src="/assets/img/icons/3d.svg" class="type-icon" *ngSwitchCase="ObjectType.MODEL3D" alt="" />
                        <mat-icon *ngSwitchDefault class="type-icon">help_outline</mat-icon>
                      </ng-container>
                    </ng-container>

                    <ng-template #showLayerIcon>
                      <img src="/assets/img/icons/layer.svg" class="type-icon" alt="" />
                    </ng-template>

                    <ng-container *ngIf="node.isSubtype" [ngSwitch]="getObjectTypeForSubtype(node)">
                      <img src="/assets/img/icons/unknown.svg" class="type-icon" *ngSwitchCase="ObjectType.UNKNOWN" alt="" />
                      <img src="/assets/img/icons/point.svg" class="type-icon" *ngSwitchCase="ObjectType.POINT" alt="" />
                      <img src="/assets/img/icons/line.svg" class="type-icon" *ngSwitchCase="ObjectType.LINE" alt="" />
                      <img src="/assets/img/icons/area.svg" class="type-icon" *ngSwitchCase="ObjectType.AREA" alt="" />
                      <img src="/assets/img/icons/3d.svg" class="type-icon" *ngSwitchCase="ObjectType.MODEL3D" alt="" />
                      <mat-icon *ngSwitchDefault class="type-icon">help_outline</mat-icon>
                    </ng-container>

                    <span *ngSwitchCase="'LayerName'" class="layer-name" [ngClass]="{ subtype: node.isSubtype }" #layerNames>
                      {{ node[row.key] }}
                      <ng-container *ngIf="node.isSubtype && node.DisplayName">({{ node.DisplayName }})</ng-container>
                    </span>
                  </div>
                  <!--End LayerName Column-->

                  <div *ngIf="!node.isSubtype">
                    <ng-container class="gold-bookmark" *ngSwitchCase="'IsFavorite'">
                      <span *ngIf="node.IsFavorite"><img src="/assets/img/icons/gold-bookmark.png" alt="" /></span>
                      <span *ngIf="!node.IsFavorite"></span>
                    </ng-container>
                  </div>

                  <!--Colors-->
                  <ng-container *ngSwitchCase="'MainColor'">
                    <span class="row-color" [style.color]="getTextColor(node[row.key])">{{ node[row.key] || "-" }}</span>
                  </ng-container>
                  <ng-container *ngSwitchCase="'SecondColor'">
                    <span class="row-color" [style.background-color]="node[row.key]" [style.color]="getTextColor(node[row.key])">
                      {{ node[row.key] || "-" }}
                    </span>
                  </ng-container>

                  <ng-container *ngSwitchCase="'ProcessedPercent'">
                    <div class="processedPercent-place" [ngClass]="getProcessedClass(node[row.key])">
                      <div class="tooltip-place">
                        <div>{{ node[row.key] }}&nbsp;&nbsp;</div>
                        <div class="status-icons" *ngIf="node[row.key + '-tooltip'] && node[row.key + '-tooltip'].length">
                          <mat-icon class="percent-status" [ngClass]="getProcessedIconClass(node[row.key + '-tooltip'])">
                            report_problem
                          </mat-icon>
                        </div>
                        <div class="table-tooltip" *ngIf="node[row.key + '-tooltip'] && node[row.key + '-tooltip'].length">
                          <ul>
                            <li *ngFor="let data of node[row.key + '-tooltip']">
                              <span class="stat-title">{{ data.key }} : </span>
                              <span class="stat-value">{{ data.value }}</span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </ng-container>

                  <ng-container *ngSwitchCase="'InspectionForms'">
                    <div class="tooltip-place">
                      {{ node[row.key] }}
                      <div class="table-tooltip" *ngIf="node[row.key + '-tooltip'] && node[row.key + '-tooltip'].length">
                        <ul>
                          <li *ngFor="let form of node[row.key + '-tooltip']">
                            {{ form }}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </ng-container>

                  <ng-container *ngSwitchDefault>
                    <ng-container *ngIf="row.type === 'boolean'">
                      <mat-icon class="mat-done" [class.enabled]="node[row.key]" [class.disabled]="!node[row.key]"> done </mat-icon>
                    </ng-container>
                    <ng-container *ngIf="row.type !== 'boolean'">
                      <span>{{ node[row.key] }}</span>
                    </ng-container>
                  </ng-container>
                </td>
              </tr>
            </ng-container>
          </ng-template>

          <!--Begin context menu -->

          <div class="context-menu">
            <div
              style="visibility: hidden; position: fixed"
              [style.left]="contextMenuPosition.x"
              [style.top]="contextMenuPosition.y"
              [matMenuTriggerFor]="contextMenu"
            ></div>
            <mat-menu #contextMenu="matMenu" class="configuration-menu">
              <ng-template matMenuContent let-node="node">
                <div
                  class="copy-config"
                  style="display: flex"
                  mat-menu-item
                  [ngClass]="{ disabled: isCopyConfigOptionDisabled() }"
                  (click)="openCopyConfigWindow()"
                >
                  <mat-icon>system_update_alt</mat-icon>
                  <span>{{ "sources.configuration.copyConfig" | translate }}</span>
                </div>

                <div *ngIf="rootFeatureLayerConfiguration.IsFavorite" class="remove-favorite" mat-menu-item style="display: flex" (click)="removeFromFavorites()">
                  <mat-icon>bookmark</mat-icon>
                  <span>{{ "sources.configuration.removeFromFavorites" | translate }}</span>
                </div>

                <div *ngIf="!rootFeatureLayerConfiguration.IsFavorite" class="add-favorite" mat-menu-item style="display: flex" (click)="addToFavorites()">
                  <mat-icon>bookmark_outline</mat-icon>
                  <span>{{ "sources.configuration.addToFavorites" | translate }}</span>
                </div>

                <div *ngIf="isSetTemplateAvailable" class="set-template" mat-menu-item (click)="setAsTemplate()">
                  <mat-icon svgIcon="template-outline"></mat-icon>
                  <span>{{ "sources.configuration.setAsTemplate" | translate }}</span>
                </div>
              </ng-template>
            </mat-menu>
          </div>

          <!--End context menu -->

          <ng-template #tableTemplate let-context>
            <table
              class="table table-condensed"
              matSort
              (matSortChange)="sortData($event)"
              [class.table-bordered]="context.fixed"
              [class.table-fixed]="context.fixed"
              [class.table-scrollable]="!context.fixed"
            >
              <thead>
                <tr *ngIf="context.fixed" class="synchronize-structure-row">
                  <th>
                    <button
                      class="synchronize-structure--btn"
                      mat-button
                      (click)="onSyncStructure()"
                      [disabled]="isSyncInProgress || isSynchronizeButtonDisabled()"
                      [hidden]="isChanged"
                    >
                      <mat-icon>cached</mat-icon>
                      {{ "configuration-page.buttons.synchronize" | translate }}
                    </button>
                  </th>
                </tr>
                <!--END ObjectType Groups-->

                <tr [ngClass]="{ 'content-fixed-row': context.fixed }">
                  <th *ngFor="let row of context.rows">
                    <span *ngIf="!context.fixed" [mat-sort-header]="row.key">
                      {{ row.title | translate }}
                    </span>
                    <span *ngIf="context.fixed">
                      {{ row.title | translate }}
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <ng-container
                  [ngTemplateOutlet]="recursiveList"
                  [ngTemplateOutletContext]="{
                    $implicit: {
                      rows: context.rows,
                      list: context.list,
                      fixed: context.fixed
                    }
                  }"
                >
                </ng-container>
              </tbody>
            </table>
          </ng-template>

          <div class="mapping-table-wrapper">
            <div class="table-group">
              <div class="fixed-table-place">
                <ng-container
                  #fixedContainer
                  [ngTemplateOutlet]="tableTemplate"
                  [ngTemplateOutletContext]="{
                    $implicit: {
                      fixed: true,
                      rows: fixedRows,
                      list: orderableList
                    }
                  }"
                >
                </ng-container>
              </div>
              <div class="table-scroll-wrapper" (scroll)="onScroll($event)" #scrollingTableOrigin>
                <ng-container
                  #mainTable
                  [ngTemplateOutlet]="tableTemplate"
                  [ngTemplateOutletContext]="{
                    $implicit: {
                      rows: tableRows,
                      list: orderableList
                    }
                  }"
                >
                </ng-container>
              </div>
            </div>
          </div>

          <div class="config-panel" [ngClass]="{ activated: activatedNodePanel }">
            <div class="top-actions">

              <div class="selected-nodes-count" *ngIf="isMultiselectModeActive">
                <span>
                  {{ selectedNodesIds.length }}
                  {{ "configuration-page.selectedLayers" | translate }} :
                </span>
              </div>

              <div class="selected-node-name" [matTooltip]="getMultiSelectLayersToolTipText()">
                <span class="selected-layer-name"
                      *ngIf="activatedNode && !isMultiselectModeActive">{{ activatedNode.LayerName }}</span>
                <span class="selected-layer-name"
                      *ngFor="let layer of getMultiSelectLayersName()">{{ layer }};</span>
              </div>

              <div class="actions-place">
                <button mat-button *ngIf="false" (click)="cancelLayer(activatedNode.Id)">
                  <mat-icon>undo</mat-icon>
                  {{ "configuration-page.buttons.cancel-local" | translate }}
                </button>

                <button
                  color="primary"
                  class="sample-data-button"
                  mat-button
                  *ngIf="!isMultiselectModeActive && placemarks && placemarks.length"
                  (click)="openSampleDataModal()"
                >
                  {{ "sources.sample-data.title" | translate }}
                </button>

                <button
                  color="primary"
                  class="sample-data-button"
                  mat-button
                  *ngIf="!isMultiselectModeActive && bimNodes && bimNodes.length"
                  (click)="openBimNodesData()"
                >
                  Sample Data
                </button>

                <button mat-button (click)="deactivateNode()" matTooltip="Press esc">
                  <mat-icon>clear</mat-icon>
                </button>
              </div>
            </div>
            <div class="form-place">
              <div class="configuration_hints">
                <div class="configuration">
                  <ng-container *ngIf="activatedNode && !isActivatedNodeSubtype">
                    <mee-configuration-tab-new
                      [node]="activatedNode"
                      [isUpdate]="isConfigurationUpdateInProgress"
                      [dataSourceSettings]="configuration.DataSource"
                      [sourceType]="typeOfSource"
                      [companySlug]="companySlug"
                      [sourceSlug]="sourceSlug"
                      [coordinateSystems]="coordinateSystems"
                      [isSourceRealTime]="isRealTime"
                      [isModelLevel]="isModelLevel"
                      [placeMarksFields]="placemarksFields"
                      [bimNodes]="bimNodes"
                      [selectedNodesIds]="selectedNodesIds"
                      [newNodeAfterCopyConfig]="newNodeAfterCopyConfig"
                      (nodeChanged)="onChangeModels($event)"
                      (nodeChangedAfterCopyConfig)="onChangeNodeAfterCopyConfig($event)"
                      (fieldsValueInSelectedLayersChanged)="onChangeSelectedLayersFieldsValue($event)"
                      (modelProjectionTypeChanged)="onModelProjectionTypeChanged($event)"
                    ></mee-configuration-tab-new>
                  </ng-container>

                  <ng-container *ngIf="activatedNode && isActivatedNodeSubtype">
                    <mee-subtype-configuration-new
                      [node]="activatedNode"
                      [placeMarksFields]="placemarksFields"
                      [subtypeParentObjectTypeConfig]="subtypeParentObjectTypeConfig"
                      [sourceType]="typeOfSource"
                      (onSubtypeConfigChanged)="subtypeConfigChanged($event)"
                    >
                    </mee-subtype-configuration-new>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </mat-tab>

        <mat-tab label="{{ 'sources.generalTab' | translate }}">
          <mee-source-form
            [isTypeDisabled]="true"
            [isCurrentDSInProcessing]="isCurrentDSInProcessing"
            (formChange)="onDataSourceFormChange($event)"
            [processingLogs]="processingLogs"
            [statistic]="rootFeatureLayerStatistic"
            [dataSource]="_currentDataSource"
          >
            <mee-script-editor-tab
              [(model)]="configuration.DataSource.MapParsingRules"
              (onChange)="onScriptChanged($event)"
            ></mee-script-editor-tab>
          </mee-source-form>
        </mat-tab>

        <mat-tab label="{{ 'sidebar.teams' | translate }}" [disabled]="!sourceTeams">
          <mee-source-teams [sourceTeams]="sourceTeams" (changeSourceTeams)="onChangeSourceTeams($event)"></mee-source-teams>
        </mat-tab>
      </mat-tab-group>

      <div class="hints" *ngIf="isDisplayHints">
        <mee-configuration-hints [configurationHints]="configurationHints"></mee-configuration-hints>
      </div>
    </div>
  </mat-card>
</div>
